import { forwardRef, useImperativeHandle, useEffect } from "react";
import "@innovatrics/dot-document-auto-capture";

const DocumentCamera = forwardRef((props, ref) => {
  // Initialize component with props
  useEffect(() => {
    const element = document.getElementById('x-dot-document-auto-capture');
    if (element) {
      element.cameraOptions = props;
    }
  }, [props]);

  useImperativeHandle(ref, () => ({
    stopCameraStreams: () => {
      try {
        console.log('[CameraInnov] Attempting to stop Innovatrics camera...');
        const innovatricsElement = document.getElementById('x-dot-document-auto-capture');
        if (!innovatricsElement) {
            console.warn('[CameraInnov] Innovatrics element not found');
            return;
        }

        // Method 1: Use component's native stop if available
        if (typeof innovatricsElement.stopCamera === 'function') {
          console.log('[CameraInnov] Using native stopCamera method');
          innovatricsElement.stopCamera();
          return;
        }

        console.log('[CameraInnov] Native method not available, using manual stop');
        // Method 2: Precise DOM traversal for video element
        const videoContainer = innovatricsElement.firstElementChild;
        if (videoContainer) {
          const videoElement = videoContainer.querySelector('video');
          if (videoElement?.srcObject) {
            console.log(`[CameraInnov] Current video resolution for auto-capture stream: ${videoElement.videoWidth}x${videoElement.videoHeight}`);
            videoElement.srcObject.getTracks().forEach((track) => {
              console.log("[CameraInnov] Stopping track:", track?.kind, track?.id); 
              track.stop();
              console.log("[CameraInnov] Track stopped:", track?.readyState); 
            });
            videoElement.srcObject = null;
          }
        }else{
            console.warn('[CameraInnov] Video container not found');
        }
      } catch (error) {
        console.error('[CameraInnov] Error stopping Innov camera:', error);
      }
    },
    getVideoElement: () => {
      const element = document.getElementById('x-dot-document-auto-capture');
      return element?.firstElementChild?.querySelector('video')?.srcObject;
    }
  }));

  return <x-dot-document-auto-capture id="x-dot-document-auto-capture" />;
});

export default DocumentCamera;